import { ContentClass } from '../../Shared/enums';

/**
 * Whether conversational (AI) search is available for a given content class.
 * Video is always supported; audio is gated behind the
 * `showConversationalSearchAudio` flag; images are not yet supported.
 */
export function isConversationalSearchEnabledForContentClass(
  contentClass: ContentClass | null,
  showConversationalSearchAudio: boolean
): boolean {
  const supportedContentClasses = [ContentClass.Video];
  if (showConversationalSearchAudio) {
    supportedContentClasses.push(ContentClass.Audio);
  }
  return contentClass != null && supportedContentClasses.includes(contentClass);
}
